import {
  ONBOARD_SET,
  ONBOARD_REQ,
  ONBOARD_SUCCESS,
  ONBOARD_ERROR
} from './onboard.type'

import ApiRest from '@/api/api-rest'

const state = {
  onboardReqStatus: '',
  customerOnboarded: false
}

const getters = {
  onboardReqStatus: state => state.onboardReqStatus,
  customerOnboarded: state => state.customerOnboarded
}

// Best Practice - updates state
const mutations = {
  [ONBOARD_SET]: (state, data) => {
    state.customerOnboarded = data
  },
  [ONBOARD_REQ]: state => {
    state.onboardReqStatus = 'loading'
  },
  [ONBOARD_SUCCESS]: (state, data) => {
    state.onboardReqStatus = 'saved'
  },
  [ONBOARD_ERROR]: (state, errMsg) => {
    state.onboardReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ONBOARD_REQ] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(ONBOARD_REQ)
      ApiRest()
        .post('/onboard', {
          onboard: payload.onboard
        })
        .then(({ data }) => {
          context.commit(ONBOARD_SET, payload.onboard)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ONBOARD_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ONBOARD_SUCCESS] (context) {
    context.commit(ONBOARD_SUCCESS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/onboard/onboard.module.js